module.exports = __webpack_public_path__ + "img/card_bg.6fbd5271.png";